import { Injectable } from '@angular/core';

// services
import { ConfigService } from '@campfire-nx/api';

@Injectable({
  providedIn: 'root'
})
export class ClaimDetailsService {
  claim!: any;

  constructor(private configService: ConfigService) { }

  getClaimType(productType: string, eventType: string) {
    let claimTypeLabel!: string;
    const claimTypes = this.configService.data?.types?.claimTypes &&
      this.configService.data.types.claimTypes[productType];
    const claimEventTypes = this.configService.data?.types.claimEventTypes;

    if (!claimTypes) {
      return claimTypeLabel;
    }

    for (const claimKey of Object.keys(claimTypes)) {
      const eventValue = claimEventTypes[claimKey]?.[eventType];
      if (eventValue?.label) {
        claimTypeLabel = eventValue.label;
        break;
      }
    }

    return claimTypeLabel;
  }

  getClaimStatus(isTpaClaim: boolean, claimState: string) {
    if (isTpaClaim) {
      const tpaClaimStateLabels: { [key:string]: string }   = {
        open_new: 'Open - New',
        open_info_missing: 'Open - Info Missing',
        open_all_info_received: 'Open - All Info Received',
        open_payout_calculation: 'Open - Payout Calculation',
        open_payout: 'Open - Payout',
        open_authorization: 'Open - Authorization',
        settled_within_excess: 'Settled - Within Excess',
        settled_full: 'Settled - Full',
        settled_partial: 'Settled - Partial',
        declined: 'Decline',
        closed_withdrawn: 'Closed - Withdrawn',
        closed_walkaway: 'Closed - Walkaway',
        closed_reassessed_rejected: 'Closed - Reassessed (Rejected)',
        closed_reassessed_approved: 'Closed - Reassessed (Approved)',
        closed_duplicate: 'Closed - Duplicate',
        reopened_new_info: 'Reopened - New Info',
        reopened_reassessment: 'Reopened - Reassessment',
        fraud_checks_under_investigation: 'Fraud Checks - Under Investigation',
        on_hold_referred_to_uw: 'On Hold - Referred to UW',
        under_insurer_review: 'On Hold - Under Insurer Review',
        under_specialist_review: 'On Hold - Under Specialist Review',
        archived_redirect_to_partner: 'Archived - Redirect to Partner'
      }
      return tpaClaimStateLabels[claimState] || claimState;
    } else {
      if (!this.configService?.data?.types?.claimStates || !claimState) {
        return null;
      }

      const claimStateData = this.configService.data.types.claimStates[claimState];
      if (claimStateData?.customer?.label) {
        return claimStateData.customer.label;
      }
      return null;
    }

    if (!this.configService?.data?.types?.claimStates || !claimState) {
      return null;
    }

    const claimStateData = this.configService.data.types.claimStates[claimState];
    if (claimStateData?.customer?.label) {
      return claimStateData.customer.label;
    }
    return null;
  }

  // eslint-disable-next-line class-methods-use-this
  getClaimStatusVariant(claimState: string) {
    // // Our claim States
    // F: Finalised
    // H: On hold
    // D: Draft
    // L: Member waiting / In progress
    // Q: Finance Outstanding
    // W: Withdrawn
    // X: Void
    const statusMap : { [key: string]: string } = {
      F: 'success',
      H: 'error',
      // TPA states
      settled_within_excess: 'success',
      settled_full: 'success',
      settled_partial: 'success',
      declined: 'success',
      closed_reassessed_rejected: 'success',
      closed_reassessed_approved: 'success',
      on_hold_referred_to_uw: 'error',
      under_insurer_review: 'error',
      under_specialist_review: 'error',
      closed_withdrawn: 'inactive',
      closed_walkaway: 'inactive',
      closed_duplicate: 'inactive',
      archived_redirect_to_partner: 'inactive'
    };

    return statusMap[claimState] || 'default';
  }
}
